import { Buffer } from 'buffer/'
import { useBlockChainBalance } from 'features/approved-balance/hooks/use-blockchain-balance'
import { useLoadingOverlay } from './use-loading-overlay'
import { useOffline } from './use-offline'
import { useOnPageChangeNavigateTop } from './use-on-page-change-navigate-top'
import { useSmartContracts } from './use-smart-contracts'
import { useUserMetadata } from './use-user-metadata'

// Polyfill Buffer for browser (Solana / Anchor stack expects it on window in some paths)
//@ts-expect-error Type 'typeof Buffer' is missing the following properties from type 'BufferConstructor': copyBytesFrom, poolSize
window.Buffer = Buffer

// NOTE: the wallet that plays is published by PlayWalletEffect (shared/hooks/use-play-wallet-sync.ts), not here.

export const useAppHookParent = () => {
  useOffline()
  useUserMetadata()
  useLoadingOverlay()
  useBlockChainBalance()
  useSmartContracts()
  useOnPageChangeNavigateTop()
}
